import React, { memo, forwardRef } from "react";
const SvgCuberoot = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M5.013 10.612c.11.051.253.077.429.077.47 0 .818.095 1.045.286a.854.854 0 01.341.693.898.898 0 01-.11.462.896.896 0 01-.264.308 1.1 1.1 0 01-.363.165 1.528 1.528 0 01-.957-.044 1.684 1.684 0 01-.484-.352 2.157 2.157 0 00-.429-.352.678.678 0 00-.385-.11.832.832 0 00-.594.242.772.772 0 00-.242.583c0 .271.121.528.363.77.3.293.653.513 1.056.66.41.14.865.209 1.364.209.36 0 .711-.051 1.056-.154.352-.095.667-.242.946-.44a2.34 2.34 0 00.671-.77c.176-.315.264-.686.264-1.111 0-.22-.037-.425-.11-.616a1.723 1.723 0 00-.308-.528 1.807 1.807 0 00-.473-.407 1.925 1.925 0 00-.605-.253v-.033c.381-.103.693-.3.935-.594.25-.3.374-.667.374-1.1 0-.374-.08-.697-.242-.968a2.072 2.072 0 00-.616-.693 2.692 2.692 0 00-.88-.407 3.787 3.787 0 00-1.001-.132c-.447 0-.873.077-1.276.231-.396.147-.722.36-.979.638a1.389 1.389 0 00-.253.352.939.939 0 00-.066.352c0 .227.077.414.231.561.161.147.356.22.583.22a.802.802 0 00.418-.099c.117-.073.216-.161.297-.264.14-.169.279-.29.418-.363.147-.08.315-.121.506-.121.257 0 .484.073.682.22.198.147.297.36.297.638 0 .11-.022.22-.066.33a.722.722 0 01-.198.286.994.994 0 01-.374.198 2.114 2.114 0 01-.572.066 1.02 1.02 0 00-.429.077.653.653 0 00-.242.198.638.638 0 00-.121.231c-.015.08-.022.15-.022.209s.007.132.022.22c.022.08.062.161.121.242a.71.71 0 00.242.187z"
      />
      <path
        fill="#717171"
        d="M15 9a1 1 0 00-.92.606L9 21.461l-2.08-4.855A1 1 0 006 16H4a1 1 0 100 2h1.34l2.74 6.394a1 1 0 001.84 0L15.66 11H28a1 1 0 100-2H15z"
      />
      <rect width={10} height={12} x={17} y={13} fill="#DBDBDB" rx={2} />
    </svg>
  );
});
SvgCuberoot.displayName = "SvgCuberoot";
const MemoForwardRef = memo(SvgCuberoot);
export default MemoForwardRef;
